module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/water-mixer-bfd2ece7a6db3268f6da6055b5caaa21.svg";